<template>
  <div class="home-page">
    <div class="container">
      <div v-if="error">
        <h2>{{ error }}</h2>
      </div>

      <Suspense v-else>
        <template #default> </template>

        <template #fallback>
          <h2>Загружаем, подождите....</h2>
        </template>
      </Suspense>
    </div>
  </div>
</template>

<script setup lang="ts">
/* ---- Core ---- */
import { onErrorCaptured, ref } from 'vue';
import { useRouter } from 'vue-router';
import type { AxiosError } from 'axios';

/* ---- State ---- */
const error = ref();
const router = useRouter();
</script>

<style lang="scss" scoped>
.home-page {
  width: 100%;
  height: 100%;
  background-color: #fdfdfe;
}

.container {
  max-width: 1040px;
  height: 100%;
  padding: 0 auto;
}

.container > header {
  font-size: 3.2rem;
  font-weight: 500;
}

.card {
  padding: 30px 55px;
  background-color: $white;
  border-radius: 1.2em;
  min-height: 200px;
}

.card__header {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  h1 {
    font-size: 1.8rem;
  }
}

.roles {
  list-style: none;
  color: $blue;
  padding-left: 64px;
}

.roles__item > span {
  font-size: 1.6rem;
  line-height: 2em;
}

.selected-item {
  color: $gray;
  display: none;

  &::before {
    content: ' ';
  }
}

.roles__item:hover > .selected-item {
  display: inline-block;
}

.roles > header {
  color: $dark;
  font-size: 2rem;
  line-height: 2.4em;
}
</style>
